
  import { Vue, Component, Prop } from "vue-property-decorator";
import debounce from "lodash-es/debounce";

  @Component({})
  export default class ScrollableContainerV2 extends Vue {
    @Prop({type: String, default: '', required: true}) readonly containerClasses!: string


@Prop({type: String, default: 'col', required: false}) readonly direction: string
@Prop({type: Number, default: 200}) readonly debounceTime!: number
get scrollClasses() {
  return {
    [this.containerClasses]: true,
    'flex-col': this.direction === 'col',
    'overflow-x-auto overflow-y-hidden': !(this.direction === 'col'),
    'overflow-y-auto overflow-x-hidden': this.direction === 'col'
  }
}

    onScrollHandle = debounce((e) =>{
      const { scrollTop, offsetHeight, scrollHeight } = e.target
          this.$emit('scroll:scroll_end', e);
        if ((scrollTop + offsetHeight) >= scrollHeight) {
          this.$emit('scroll:end_reach', e);
        }
    }, this.debounceTime )
  }
